module.exports = __webpack_public_path__ + "mybuild/static/img/footerlogo01.59f46053.png";